import { Component } from '@angular/core';

@Component({
  selector: 'app-appmgr',
  templateUrl: 'appmgr.component.html'
})
export class AppmgrComponent {
  title = 'App Mgr';
}